
<template>
    <div>
		<div class="row">
			<div class="col-5 mb-4">
				<h1>{{ $t("placement-providers") }}</h1>
			</div>
			<div class="col-7 mb-4">
				<router-link to="/placement-providers/add" class="float-right btn btn-primary"
					><b-icon icon="plus"></b-icon> {{ $t("new") }}
				</router-link>
			</div>
		</div>
        <div v-if="addEnabled" class="col-7 mb-4">
            <router-link to="/placement-providers/add" class="float-right btn btn-primary"
                ><b-icon icon="plus"></b-icon> {{ $t("new") }}</router-link
            >
        </div>
		<div class="row">
			<div class="col-md-12">
				<Table
					:loading="loading"
					:submitting="submitting"
					:cols="[
						{ key: 'title', heading: $t('name'), size: 3, sortable: false },
                        { key: 'note', heading: $t('notes'), size: 4, sortable: false }
					]"
					:data="providers"
					breakpoint="md"
					:filters="{
						...filters,
						page: filters.page,
						page_size: filters.page_size,
						total: total,
					}"
               		:searchable="true"
                	:scrollPaginate="true"
					@refresh="refresh"
					@toPage="toPage"
					@selectItem="provider => $router.push(`/placement-providers/${provider.id}`)"
                    @deleteItem="openDeleteDialog"
                    :allowRightClick="true"
				>
					<!-- Table Header -->
					<template v-slot:header>
					</template>
				</Table>
			</div>

		</div>
    </div>
</template>
<script>
import Table from "src/components/Table/Table.vue";

export default {
	components: {
        Table,
	},
    data() {
        return {
            addEnabled: false, //for debugging purposes
        	total: 0 ,
            filters: {
                page: 1,
                page_size: 30,
                search: '',
                sort: '',
                order: '',
            },
            loading: true,
            submitting: false,
            providers: [],
            selectedProvider:null
        }

    },
    mounted() {
        this.listProviders();
    },
    methods: {
        listProviders() {
            if (this.submitting) return;
            this.submitting = true;
            this.$cfetch(`${this.$settings.APIBaseURL}/placementprovider/list`,{
                method: "post",
                data: this.filters
            })
            .then((res) => {

				if (res.status === "SUCCESS") {
                    this.providers=res.results;
            		this.loading = false;
                	this.filters.page = res.pagination.page
                	this.filters.page_size = res.pagination.page_size
                	this.total = res.pagination.total
				} else {
					this.$log.info.call(this, status)
				}
            	this.submitting = false;
			}).catch(error => {
            	this.submitting = false;
				this.$log.error.call(this, error);
			});
        },
        refresh(filters) {
            this.filters = { ...this.filters, ...filters }
            this.listProviders();
        },
        toPage(pageNo) {
            this.filters.page = pageNo
            this.listProviders();
        },
        openDeleteDialog(provider) {
            this.selectedProvider = provider

            this.$store.commit('openDialog', {
                title: this.$t('are-you-sure'),
                content: this.$t('delete-{e}-warning',{e: this.$t('provider')}),
                cancelBtn: true,
                confirmCallBack: this.removeProvider,
            })
        },
        removeProvider() {
            if (!this.selectedProvider) return ;
            this.$cfetch(`${this.$settings.APIBaseURL}/placementprovider/delete`, {
                method: 'POST',
                data: { id: this.selectedProvider.id }
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error('Unexpected error deleting provider')

                this.providers = this.providers.filter(el => el.id !== this.selectedProvider.id)
            }).catch(err => {
                console.error(err)
                this.$log.error.call(this, err)
                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    content: this.$t('error-delete-{e}',{e:this.$t('provider')}),
                })
            }).finally(() => {
                this.selectedTag = undefined
            })
        }

    },
    computed: {
    }
};
</script>
